import React from "react";
import * as ANTD from "antd";
import notFound from "../../assets/images/error/notfound.png";
import { Link } from "react-router-dom";
import "./unauth.scss";
const NoResultFound = () => {
  return (
    <div className="unauthorized">
      {console.log("rtr404")}
      <ANTD.Result
        icon={<img src={notFound} alt="404" />}
        title="404"
        subTitle={
          <div>
            <p className="dec">
              Sorry the page you
              <br /> visited does not exist
            </p>
          </div>
        }
        extra={
          <Link to="/">
            <ANTD.Button type="primary">Back Home</ANTD.Button>
          </Link>
        }
      />
    </div>
  );
};

export default NoResultFound;
